var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{domProps:{"value":_vm.locale},on:{"change":_vm.change}},_vm._l((_vm.locales),function(language,value){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(" "+_vm._s(_vm.$t("languages." + language))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }